/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuestionSubSection } from './question-sub-section';
import { SectionTypeEnum } from './section-type-enum';


/**
 * if type question, sub_sections is filled. if type text, value is filled
 */
export interface Section { 
    title: string;
    sectionType: SectionTypeEnum;
    subSections?: Array<QuestionSubSection>;
    value?: string;
    textInfo?: string;
    placeholder?: string;
    maxTextLen?: number;
}

